import * as types from '../actions/actionTypes';

const initialState = {
  attachedToLine: [],
  waterfallSectionsData: [],
  underlaymentSections: [],

  selectedHandle: null,
  selectedHinge: null,
  selectedFeature: null,
  selectedPartIds: [],
  resourceTypes: [],
  resourceControllerCounter: 0,

  // Canvas Tools Management
  activeTool: null, // 'edge', 'backsplash', 'waterfall', etc.
  isToolActive: false,
  currentFeature: null,
  toolSettings: {
    newWizardGroupId: null,
    disallowDemo: false,
  },

  cursorVisible: false,
  toolReady: false,
};

export default function(state = {...initialState}, action) {
  let filteredResource;
  let resourceTypes;
  let newState;

  switch(action.type) {
    case types.SET_SELECTED_HANDLE:
    case types.SET_SELECTED_HINGE:
    case types.SET_SELECTED_FEATURE:
    case types.SET_SELECTED_PART_IDS:
    case types.SET_RESOURCE_CONTROLLER_COUNTER:
      return Object.assign({}, state, {
        ...action.payload
      });

    // Canvas Tools Actions
    case types.CANVAS_TOOL_ACTIVATE:
      return {
        ...state,
        activeTool: action.payload.tool,
        currentFeature: action.payload.feature,
        isToolActive: true,
        toolReady: false,
        cursorVisible: false,
        toolSettings: {
          ...state.toolSettings,
          ...action.payload.settings
        }
      };

    case types.CANVAS_TOOL_DEACTIVATE:
      return {
        ...state,
        activeTool: null,
        currentFeature: null,
        isToolActive: false,
        toolReady: false,
        cursorVisible: false
      };

    case types.CANVAS_TOOL_READY:
      return {
        ...state,
        toolReady: true,
        cursorVisible: true
      };

    case types.SET_RESOURCES:
      state = {...state, [action.payload.resourceType]: action.payload.resources};
      break;

    case types.ADD_RESOURCE:
      newState = {
        [action.payload.resourceType]: [...state[action.payload.resourceType], action.payload.resource],
      }
      if (!state.resourceTypes.includes(action.payload.resourceType)) {
        newState.resourceTypes = [...state.resourceTypes, action.payload.resourceType]
      }
      return Object.assign({}, state, newState);

    case types.CHANGE_RESOURCE:
      filteredResource = state[action.payload.resourceType].map((item) => {
        if (item.id !== action.payload.resource.id) { return item }

        return {
          ...item,
          ...action.payload.resource
        }
      })

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });

    case types.DELETE_RESOURCE:
      filteredResource = state[action.payload.resourceType].filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });

    case types.DELETE_RESOURCE_ATTACHED_TO:
      filteredResource = state[action.payload.resourceType].filter((row) => row.attachedToId !== action.payload.attachedTo.id);

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });

    case types.DELETE_ALL_RESOURCES:
      resourceTypes = {}
      for (const resourceType of state.resourceTypes) {
        resourceTypes[resourceType] = [];
      }
      return Object.assign({}, state, resourceTypes);

    default:
      return state;
  }

  return state;
}
